import React from 'react';

export function LicenseLink() {
  return (
    <span>
      <a href="https://www.softekinc.com/licenses/home">Open Source License Information</a>
    </span>
  );
}
